const AGG_NAMES = {
  envia: "Tendencys",
  pak2go: "Epak",
  interpack: "Interpack",
  skypractico: "SkyPractico",
  srsimi: "SrSimi",
  elogicya: "ELogicYa",
  sigomx: "SigoMx",
  enviot2: "EnvioT2",
  bhgc: "BHGC Nexus",
  shipwoo: "ShipWoo",
  genienvios: "GeniEnvios",
  multipaq: "MultiPaq",
  mydhl: "SGM",
  directo: "Convenio directo",
  interno: "Convenio directo",
  simulated: "Simulada",
  // Fuentes de rastreo en vivo (trackShipmentLive / publicTrackShipment)
  "universal:17track": "17TRACK",
  "universal:aftership": "AfterShip",
  external: "API del carrier"
};

// Devuelve la etiqueta legible del origen de una guía/recolección/tarifa.
//
// `source` es el canal AUTORITATIVO (mydhl, envia, pak2go, interno, bhgc,
// simulated...) y siempre lo setea el cotizador (quoteRunner) — no se ve
// afectado por la filtración del loop de credenciales del labelGenerator que
// ensuciaba `aggregator` en los carriers directos. Se prefiere `source` sobre
// `aggregator` para que la etiqueta sea correcta incluso en registros viejos
// con el agregador filtrado, sin requerir migración de datos.
export function getAggregatorLabel(rec) {
  if (!rec) return "";
  const src = String(rec.source || "");
  const agg = String(rec.aggregator || "");
  if (src && AGG_NAMES[src]) return AGG_NAMES[src];
  if (agg && AGG_NAMES[agg]) return AGG_NAMES[agg];
  if (src === "interno" || agg === "directo") return "Convenio directo";
  return "";
}